import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';

import MainHeader from '../MainHeader/MainHeader';
import NavLinks from '../NavLinks/NavLinks';
import SideDrawer from '../../UI/SideDrawer/SideDrawer';
import Backdrop from '../../UI/Backdrop/Backdrop';
import Sidebar from '../Sidebar/Sidebar';
import { useAuth } from '../../../hooks/useAuth';
import NewNavLinks from '../NewNavLinks/NewNavLinks';

import logo from '../../../assets/images/Athena_logo_final.png';

import './MainNavigation.css';

const MainNavigation = (props) => {
  const { isAuthenticated } = useAuth();
  const [drawerIsOpen, setDrawerIsOpen] = useState(false);
  const { setIsSidebarOpen, isSidebarOpen } = props;

  const openDrawerHandler = () => {
    setDrawerIsOpen(true);
  };

  const location = useLocation();
  const currentPath = location.pathname;
  const closeDrawerHandler = () => {
    setDrawerIsOpen(false);
  };

  if (currentPath === '/runTestBulk') {
    return null;
  }
  return (
    <React.Fragment>
      {drawerIsOpen && <Backdrop onClick={closeDrawerHandler} />}
      <SideDrawer show={drawerIsOpen} onClick={closeDrawerHandler}>
        <nav className="main-navigation__drawer-nav">
          <NavLinks />
        </nav>
      </SideDrawer>

      <MainHeader isSidebarOpen={isSidebarOpen} isAuthenticated={!!isAuthenticated}>
        <button className="main-navigation__menu-btn" onClick={openDrawerHandler}>
          <span />
          <span />
          <span />
        </button>
        {!isAuthenticated && (
          <h1 className="main-navigation__title">
            <Link to="/">
              <img src={logo} alt={'logo'} />
            </Link>
          </h1>
        )}

        <nav className="main-navigation__header-nav">
          <NewNavLinks />
        </nav>
      </MainHeader>
      {isAuthenticated && (
        <Sidebar setIsSidebarOpen={setIsSidebarOpen} isSidebarOpen={isSidebarOpen} currentPath={currentPath} />
      )}
    </React.Fragment>
  );
};

export default MainNavigation;
